import React from "react";
import MatchCard from "./components/MatchCard";
import withLogoText from "./components/withLogoText";
import WithLogoText from "./components/withLogoText";
import './index.css'
import TableGroup from "./components/TableGroup";

const ListMatchesGame = ({matches, filterByGroup, group})=>{
    return(
        <WithLogoText filterByGroup={filterByGroup} matchInfo={matches?.[0]}>
        <div className="container-list-games" >
            <div className="subcontainer-list-games" >
                <div className="conatiner-match-list-matches" >
                 {
                matches?.map((match,i)=>(
                    <MatchCard match={match} />
                ))
            }
            </div>
            {
                group !== '' && group !== 'Todos' && (
                    <TableGroup group={group} />
                )
            }
            
            
            </div>
        </div>
        </WithLogoText>

    )
}

export default ListMatchesGame